(() => {
  const allowedIso = ['P', 'M', 'K', 'N', 'S', 'H'];
  const allowedCutting = ['hartmetall', 'keramik', 'pcd'];

  const translations = {
    de: {
      materialTitle: 'Bearbeitbare Werkstoffe', all: 'Alle',
      groups: { P:'Stahl', M:'Edelstahl', K:'Gusseisen', N:'Nichteisenmetalle', S:'Titan / Superlegierungen', H:'Gehärtete Stähle' },
      cuttingTitle: 'Schneidstoff des Werkzeugs', cutting: { hartmetall:'Hartmetall', keramik:'Keramik', pcd:'PCD' },
      cardWorkpiece: 'Werkstück', cardTool: 'Werkzeug'
    },
    en: {
      materialTitle: 'Machinable workpiece materials', all: 'All',
      groups: { P:'Steel', M:'Stainless steel', K:'Cast iron', N:'Non-ferrous metals', S:'Titanium / superalloys', H:'Hardened steels' },
      cuttingTitle: 'Tool cutting material', cutting: { hartmetall:'Carbide', keramik:'Ceramic', pcd:'PCD' },
      cardWorkpiece: 'Workpiece', cardTool: 'Tool'
    },
    fr: {
      materialTitle: 'Matières usinables', all: 'Tous',
      groups: { P:'Acier', M:'Acier inoxydable', K:'Fonte', N:'Métaux non ferreux', S:'Titane / superalliages', H:'Aciers trempés' },
      cuttingTitle: 'Matériau de coupe de l’outil', cutting: { hartmetall:'Carbure', keramik:'Céramique', pcd:'PCD' },
      cardWorkpiece: 'Pièce', cardTool: 'Outil'
    }
  };

  const getLanguage = () => {
    const lang = (document.documentElement.lang || 'de').toLowerCase();
    if (lang.startsWith('en')) return 'en';
    if (lang.startsWith('fr')) return 'fr';
    return 'de';
  };

  const makeIsoBadge = (code, extraClass = '') => {
    const badge = document.createElement('span');
    badge.className = `kiso kiso--${code.toLowerCase()} ${extraClass}`.trim();
    badge.textContent = code;
    badge.title = `ISO ${code}`;
    badge.setAttribute('aria-label', `ISO ${code}`);
    return badge;
  };

  const makeCuttingBadge = (material, extraClass = '') => {
    const labels = { hartmetall:'HM', keramik:'KER', pcd:'PCD' };
    const badge = document.createElement('span');
    badge.className = `kcut kcut--${material} ${extraClass}`.trim();
    badge.textContent = labels[material] || material.toUpperCase();
    const name = translations[getLanguage()].cutting[material] || material;
    badge.title = name;
    badge.setAttribute('aria-label', name);
    return badge;
  };

  const getCardIsoGroups = (card) => (card.dataset.isoGroups || '')
    .split(/\s+/)
    .map((code) => code.toUpperCase())
    .filter((code) => allowedIso.includes(code));

  const getCardCutting = (card) => {
    const value = (card.dataset.toolMaterial || '').toLowerCase();
    return allowedCutting.includes(value) ? value : '';
  };

  const buildFilterHref = (name, value) => {
    const url = new URL(window.location.href);
    url.searchParams.delete('page');
    if (value) url.searchParams.set(name, value);
    else url.searchParams.delete(name);
    return `${url.pathname}${url.search}`;
  };

  const updateFilterLinks = () => {
    document.querySelectorAll('[data-iso-filter]').forEach((link) => {
      link.href = buildFilterHref('iso', (link.dataset.isoFilter || '').toUpperCase());
    });
    document.querySelectorAll('[data-toolmaterial-filter]').forEach((link) => {
      link.href = buildFilterHref('toolmaterial', (link.dataset.toolmaterialFilter || '').toLowerCase());
    });
  };

  const clarifyFilterHeadings = () => {
    const t = translations[getLanguage()];
    const materialTitle = document.querySelector('.kc-material-filter:not(.kc-cutting-filter) .kc-material-filter__title');
    const cuttingTitle = document.querySelector('.kc-cutting-filter .kc-material-filter__title');
    if (materialTitle) materialTitle.textContent = t.materialTitle;
    if (cuttingTitle) cuttingTitle.textContent = t.cuttingTitle;
  };

  const preserveFiltersOnNavigation = () => {
    const params = new URLSearchParams(window.location.search);
    const iso = (params.get('iso') || '').toUpperCase();
    const cutting = (params.get('toolmaterial') || '').toLowerCase();
    const hasIso = allowedIso.includes(iso);
    const hasCutting = allowedCutting.includes(cutting);


    document.querySelectorAll('.kc-subcats a, .kc__back, .pagination-wrapper a, .pagination a').forEach((link) => {
      try {
        const url = new URL(link.href, window.location.origin);
        if (url.origin !== window.location.origin) return;
        if (hasIso) url.searchParams.set('iso', iso); else url.searchParams.delete('iso');
        if (hasCutting) url.searchParams.set('toolmaterial', cutting); else url.searchParams.delete('toolmaterial');
        link.href = url.toString();
      } catch (_) {}
    });
  };

  const decorateCards = () => {
    const t = translations[getLanguage()];
    document.querySelectorAll('.kc-product').forEach((card) => {
      if (card.querySelector('.kbadge-cardset')) return;
      const groups = getCardIsoGroups(card);
      const cutting = getCardCutting(card);
      if (!groups.length && !cutting) return;

      const target = card.querySelector('.kc-product__facts');
      if (!target) return;

      const makeGroup = (label, extraClass = '') => {
        const group = document.createElement('div');
        group.className = `kbadge-cardgroup ${extraClass}`.trim();
        const caption = document.createElement('span');
        caption.className = 'kbadge-cardgroup__label';
        caption.textContent = label;
        const badges = document.createElement('div');
        badges.className = 'kbadge-cardgroup__badges';
        group.append(caption, badges);
        return { group, badges };
      };

      const set = document.createElement('div');
      set.className = 'kbadge-cardset kbadge-cardset--separated';

      if (groups.length) {
        const workpiece = makeGroup(t.cardWorkpiece);
        groups.forEach((code) => workpiece.badges.append(makeIsoBadge(code, 'kiso--card')));
        set.append(workpiece.group);
      }

      if (cutting) {
        const tool = makeGroup(t.cardTool, groups.length ? 'kbadge-cardgroup--tool' : '');
        tool.badges.append(makeCuttingBadge(cutting, 'kcut--card'));
        set.append(tool.group);
      }

      target.insertAdjacentElement('beforebegin', set);
    });
  };

  const setDisabled = (link, disabled) => {
    if (!link) return;
    link.classList.toggle('is-disabled', disabled);
    link.setAttribute('aria-disabled', disabled ? 'true' : 'false');
    if (disabled) link.setAttribute('tabindex', '-1');
    else link.removeAttribute('tabindex');
  };

  const updateFilterAvailability = (cards, activeIso, activeCutting) => {
    document.querySelectorAll('[data-iso-filter]').forEach((link) => {
      const code = (link.dataset.isoFilter || '').toUpperCase();
      if (!code) return setDisabled(link, false);
      const possible = cards.some((card) => {
        const cutting = getCardCutting(card);
        return getCardIsoGroups(card).includes(code) && (!activeCutting || cutting === activeCutting);
      });
      setDisabled(link, !possible);
    });

    document.querySelectorAll('[data-toolmaterial-filter]').forEach((link) => {
      const material = (link.dataset.toolmaterialFilter || '').toLowerCase();
      if (!material) return setDisabled(link, false);
      const possible = cards.some((card) => {
        const groups = getCardIsoGroups(card);
        return getCardCutting(card) === material && (!activeIso || groups.includes(activeIso));
      });
      setDisabled(link, !possible);
    });
  };

  const filterCollection = () => {
    const root = document.querySelector('.kc');
    if (!root) return;

    const params = new URLSearchParams(window.location.search);
    const requestedIso = (params.get('iso') || '').toUpperCase();
    const requestedCutting = (params.get('toolmaterial') || '').toLowerCase();
    const activeIso = allowedIso.includes(requestedIso) ? requestedIso : '';
    const activeCutting = allowedCutting.includes(requestedCutting) ? requestedCutting : '';
    const cards = [...root.querySelectorAll('.kc-product')];
    let visible = 0;

    cards.forEach((card) => {
      const groups = getCardIsoGroups(card);
      const cutting = getCardCutting(card);
      const showIso = !activeIso || groups.includes(activeIso);
      const showCutting = !activeCutting || cutting === activeCutting;
      const show = showIso && showCutting;
      card.hidden = !show;
      if (show) visible += 1;
    });

    const count = root.querySelector('[data-kc-product-count]');
    if (count) count.textContent = String(visible);
    root.querySelectorAll('[data-ke-result-count]').forEach(el => el.textContent = String(visible));
    const noun = root.querySelector('[data-ke-product-label]');
    if (noun) noun.textContent = visible === 1 ? noun.dataset.one : noun.dataset.many;
    const status = root.querySelector('[data-ke-filter-status]');
    if (status) {
      if (!status.dataset.default) status.dataset.default = status.textContent;
      const active = [];
      if (activeIso) active.push(translations[getLanguage()].groups[activeIso]);
      if (activeCutting) active.push(translations[getLanguage()].cutting[activeCutting]);
      status.textContent = active.join(' · ') || status.dataset.default;
      const activeBar = root.querySelector('[data-ke-active-filters]');
      if (activeBar) { activeBar.hidden = !active.length; activeBar.querySelector('[data-ke-active-label]').textContent = active.join(' · '); }
    }

    const empty = root.querySelector('[data-kc-filter-empty]');
    if (empty) empty.hidden = visible !== 0;

    root.querySelectorAll('[data-iso-filter]').forEach((link) => {
      const value = (link.dataset.isoFilter || '').toUpperCase();
      const selected = value === activeIso;
      link.classList.toggle('is-active', selected);
      if (selected) link.setAttribute('aria-current', 'page');
      else link.removeAttribute('aria-current');
    });

    root.querySelectorAll('[data-toolmaterial-filter]').forEach((link) => {
      const value = (link.dataset.toolmaterialFilter || '').toLowerCase();
      const selected = value === activeCutting;
      link.classList.toggle('is-active', selected);
      if (selected) link.setAttribute('aria-current', 'page');
      else link.removeAttribute('aria-current');
    });

    updateFilterAvailability(cards, activeIso, activeCutting);
    const cuttingGroup = root.querySelector('.kc-cutting-filter');
    if (cuttingGroup) {
      const distinct = new Set(cards.map(getCardCutting).filter(Boolean));
      cuttingGroup.hidden = distinct.size < 2 && !activeCutting;
    }
  };

  const preventDisabledClicks = () => {
    document.addEventListener('click', (event) => {
      const link = event.target.closest('.kc-material-filter__link.is-disabled');
      if (!link) return;
      event.preventDefault();
    });
  };

  const init = () => {
    clarifyFilterHeadings();
    updateFilterLinks();
    preserveFiltersOnNavigation();
    decorateCards();
    filterCollection();
    preventDisabledClicks();
    const root = document.querySelector('.kc');
    if (root && !root.dataset.keFilterBound) {
      root.dataset.keFilterBound = 'true';
      const scrollSpace = document.createElement('div');
      scrollSpace.setAttribute('aria-hidden', 'true');
      scrollSpace.dataset.keFilterScrollSpace = '';
      // Keep the current viewport reachable when the filtered results make the page shorter.
      scrollSpace.style.display = 'block';
      root.append(scrollSpace);
      let restoreFrame = 0;
      let originalOverflowAnchor = '';
      const updateWithoutScrolling = (update) => {
        const position = { left: window.scrollX, top: window.scrollY, behavior: 'instant' };
        if (restoreFrame) cancelAnimationFrame(restoreFrame);
        else originalOverflowAnchor = document.documentElement.style.overflowAnchor;
        document.documentElement.style.overflowAnchor = 'none';
        scrollSpace.style.height = '0px';
        update();
        const missingHeight = position.top + window.innerHeight - document.documentElement.scrollHeight;
        scrollSpace.style.height = `${Math.max(0, Math.ceil(missingHeight))}px`;
        window.scrollTo(position);
        restoreFrame = requestAnimationFrame(() => {
          window.scrollTo(position);
          document.documentElement.style.overflowAnchor = originalOverflowAnchor;
          restoreFrame = 0;
        });
      };
      const refreshFilters = () => {
        updateFilterLinks();
        preserveFiltersOnNavigation();
        filterCollection();
      };
      root.addEventListener('click', event => {
        const link = event.target.closest('[data-iso-filter], [data-toolmaterial-filter], [data-ke-clear-filters]');
        if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
        event.preventDefault();
        if (link.getAttribute('aria-disabled') === 'true') return;
        const url = new URL(link.href);
        updateWithoutScrolling(() => {
          if (link.hasAttribute('data-ke-clear-filters')) {
            const current = new URL(location.href);
            current.searchParams.delete('iso'); current.searchParams.delete('toolmaterial'); current.searchParams.delete('page');
            history.pushState({}, '', current.pathname + current.search);
          } else history.pushState({}, '', url.pathname + url.search);
          refreshFilters();
        });
      });
      window.addEventListener('popstate', () => updateWithoutScrolling(refreshFilters));
    }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once:true });
  else init();
})();
